<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <div id="app">
        <Header />
        <router-view class="main" />
    </div>
</template>
<script>
import Header from '@/components/Header.vue';

export default {
    components: { Header },
};
</script>
<style lang="scss">
@import '~@cumulus/air-ui-kit/variables.scss';

body {
    height: 100vh;
    width: 100vw;
    margin: 0px;
    background-color: $athens-gray !important;
}

pre {
    background-color: $athens-gray;
    overflow-y: auto;
    height: 100%;
}

#app {
    height: 100%;
    width: 100%;
}

.main {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    height: 75vh;
    width: 75vw;
    margin: auto;
    margin-top: 100px;
    text-align: center;
}

.m-20 {
    margin: 20px;
}

.mb-40 {
    margin-bottom: 40px;
}

.mt-0 {
    margin-top: 0px;
}

.mt-40 {
    margin-top: 40px;
}

.my-20 {
    margin: 20px 0px;
}

.p-10 {
    padding: 10px;
}

.pl-5 {
    padding-left: 5px;
}

.pr-20 {
    padding-right: 20px;
}

.pt-10 {
    padding: 10px 0 0 0;
}

.pt-20 {
    padding-top: 20px;
}

.pt-40 {
    padding-top: 40px;
}

.px-10 {
    padding: 0 10px;
}

.vm--modal {
    padding: 20px;
}
</style>
